<mat-dialog-content class="expanded-view-container">
  <div class="expanded-view-header">
    <h4 class="expanded-view-title">{{ data.viewTitle }}</h4>
    <mat-dialog-actions align="end">
      <mat-icon
        svgIcon="reduce"
        class="expanded-view-resize-small-icon"
        (click)="close()"
      ></mat-icon>
    </mat-dialog-actions>
  </div>
  <div class="expanded-view-divider">
    <p
      class="expanded-view-subtitle"
      *ngIf="data.viewDescription !== undefined && data.viewDescription !== ''"
    >
      {{ data.viewDescription }}
    </p>
    <ng-container>
      <chips-list [filterService]="data.filterService"></chips-list>
    </ng-container>
  </div>
  <chart
    *ngIf="data.chartType === 'default'"
    [sortedData]="sortedData$ | async"
    [chartOption]="data.chartOption"
    [showAllKeys]="data.showAllKeys"
    [field]="data.field"
  ></chart>
  <trend-chart
    *ngIf="data.chartType === 'trend'"
    class="trend-chart"
    [trendChartData]="currentExpandedData || data.expandedTrendChartData"
    [size]="chartSize"
    [kpiKey]="currentKpiKey"
  ></trend-chart>
  <chart
    *ngIf="data.chartType === 'bar'"
    [chartTitle]="''"
    [sortedData]="(currentExpandedData || data.expandedBarChartData)?.values"
    [isKpiData]="true"
    [showAllKeys]="true"
    [initOption]="initKpiOptionLarge"
    [chartOption]="kpiBar"
    [kpiChartSize]="'large'"
    [kpiOnTrack]="(currentExpandedData || data.expandedBarChartData)?.onTrack"
    [kpiOnTarget]="(currentExpandedData || data.expandedBarChartData)?.onTarget"
    [kpiChartIdentifier]="(currentExpandedData || data.expandedBarChartData)?.identifier"
    [isPercent]="(currentExpandedData || data.expandedBarChartData)?.config?.isPercent ?? false"
    [filterService]="data.filterService"
    [field]="data.fieldFilter"
    [kpiXAxisLabel]="(currentExpandedData || data.expandedBarChartData)?.xAxisLabel"
  ></chart>
  <chart
    *ngIf="data.chartType === 'pie'"
    [sortedData]="(currentExpandedData || data.expandedPieChartData)?.values"
    [isKpiData]="true"
    [initOption]="initKpiOptionLarge"
    [chartOption]="pie"
    [kpiChartSize]="'large'"
    [colorMap]="colorMap"
    [showAllKeys]="true"
    [chartBaseTitle]="(currentExpandedData || data.expandedPieChartData)?.xAxisLabel"
    [filterService]="data.filterService"
    [field]="data.fieldFilter"
  />
  <grouped-bar-chart
    *ngIf="data.chartType === 'groupedBar'"
    [sortedData]="(currentExpandedData || data.expandedGroupedBarChartData)?.values"
    [initOption]="initKpiOptionLarge"
    [chartOption]="groupedBar"
    [kpiChartSize]="'large'"
    [kpiOnTrack]="(currentExpandedData || data.expandedGroupedBarChartData)?.onTrack"
    [kpiOnTarget]="(currentExpandedData || data.expandedGroupedBarChartData)?.onTarget"
    [kpiChartIdentifier]="(currentExpandedData || data.expandedGroupedBarChartData)?.identifier"
    [isPercent]="
      (currentExpandedData || data.expandedGroupedBarChartData)?.config?.isPercent ?? false
    "
    [filterService]="data.filterService"
    [field]="data.fieldFilter"
    [kpiXAxisLabel]="(currentExpandedData || data.expandedGroupedBarChartData)?.xAxisLabel"
  ></grouped-bar-chart>

  <drilldown-table
    *ngIf="data.chartType === 'table'"
    [data]="currentExpandedData || data.tableData"
    [size]="chartSize"
  ></drilldown-table>

  <drilldown-toggle-chart
    *ngIf="data.chartType === 'toggle'"
    [toggleChartData]="currentExpandedData || data.toggleChartData"
    [chartSize]="chartSize"
    [kpiKey]="currentKpiKey"
  ></drilldown-toggle-chart>
</mat-dialog-content>
